// extracted by mini-css-extract-plugin
module.exports = {"ratesTable":"_3XOIv7vrQ0HKFDlLYCJVzF"};